import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  templateUrl: './request-notification-dialog.component.html',
  styleUrls: ['./request-notification-dialog.component.css']
})
export class RequestNotificationDialogComponent implements OnInit {
  defaultTitle: string = 'Enable Notifications!';

  constructor(
    private dialogRef: MatDialogRef<RequestNotificationDialogComponent>
  ) { }

  ngOnInit() {
  }

  enable() {
    this.dialogRef.close({
      enable: true
    });
  }

  cancel() {
    this.dialogRef.close({
      enable: false
    });
  }

}

